module.exports = __webpack_public_path__ + "static/media/excel.69d4ac35.png";